/**
 * 深拷贝
 *
 * @param obj - 目标对象
 * @returns {*}
 */

/* eslint-disable */
export const deepCopy = (obj) => {
  if (obj === null || typeof (obj) !== 'object') {
    return obj;
  }

  if ('isActiveClone' in obj) {
    throw new Error('循环引用警告⚠️');
  }

  let temp;
  if (obj instanceof Date) {
    temp = new obj.constructor();
  } else {
    temp = obj.constructor();
  }

  Object.keys(obj).forEach((key) => {
    obj.isActiveClone = null;
    temp[key] = deepCopy(obj[key]);
    delete obj.isActiveClone;
  });
  return temp;
};




// WEBPACK FOOTER //
// ./src/components/grid/utils.js